import React from 'react'
import T from 'prop-types'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'

const classes = {
  carSpecificationsItem: 'car-specifications-item',
}
const Root = styled(Typography)(({ theme }) => ({
  [`&.${classes.carSpecificationsItem}`]: {
    display: 'flex',
    alignItems: 'center',
    '&:first-of-type': {
      paddingBottom: theme.spacing(1),
    },
  },
}))

export default function CarSpecification({ icon, value, ...others }) {
  return (
    <Root
      variant="body2"
      color="textPrimary"
      {...others}
      sx={{ pr: 1.5, ...others?.sx }}
      className={classes.carSpecificationsItem}
    >
      <icon.type {...icon.props} fontSize="small" sx={{ mr: 1 }} />
      <span>{value}</span>
    </Root>
  )
}

CarSpecification.propTypes = {
  icon: T.object.isRequired,
  value: T.string,
  others: T.object,
}
